import {
  adminTableData,
  adminTableHead,
  emailAccounts,
  emailAccounts1,
  strategicPlanning,
} from "@assets/mocks/tableData";
import Iconify from "@components/iconify";
import { Button } from "@components/ui/button";
import * as Select from "@radix-ui/react-select";
import ReactPaginate from "react-paginate";
import { IconButton } from "@mui/material";
import { IoAdd } from "react-icons/io5";
import React, { useEffect, useState } from "react";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import Table from "@components/Table";
import { useNavigate } from "react-router";
import SearchInput from "@components/ui/searchInput";
import {
  EmailAccount,
  getAllEmailAccounts,
  deleteEmailAccount,
  getEmailAccountById,
} from "@redux/slices/email";
import useAuth from "@hooks/useAuth";
import { Switch } from "@components/ui/switch";
import LoadingScreen from "@components/LoadingScreen";

const EmailAccountsById = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [itemOffset, setItemOffset] = useState(0);
  const [accounts, setAccounts] = useState<EmailAccount[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const id = window.location.pathname.split("/")[2];
  console.log(id);

  const getData = async () => {
    const accountsData = await getEmailAccountById(id);
    setAccounts(accountsData || []);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
    setItemOffset(0);
  };

  const handleDeleteAccount = async (accountId: number) => {
    await deleteEmailAccount(accountId);
    getData();
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  const filteredAccounts = accounts.filter((account) =>
    account.email.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const endOffset = itemOffset + 5;
  const currentItems = filteredAccounts.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredAccounts.length / 5);

  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * 5) % filteredAccounts.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="md:flex justify-end items-center mt-7">
            <div className="sm:flex items-center">
              {/* <div className="flex items-center me-4">
              <p className="text-gray me-2">Search by users</p>
              <Switch/>
            </div> */}
              <div className="me-2">
                <div className="relative">
                  <input
                    className="appearance-none placeholder:text-[#B5B7C0] placeholder:text-sm placeholder:ps-1 border-0 pl-10 border-[#e2e8f0] bg-white shadow-sm  transition-colors rounded-md w-full py-2 px-3 text-gray-800 leading-tight focus:outline-none"
                    id="username"
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />

                  <div className="absolute left-0 inset-y-0 flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 ml-3 text-gray-400 hover:text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="#71717A"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Table textIndex={2} tableHead={emailAccounts1}>
            {currentItems.map((val, index) => (
              <tr
                key={val.id}
                className="text-sm text-gray text-center border-b last:border-0 border-[#EAECF0]"
              >
                <td className="p-5 w-16">{itemOffset + index + 1}</td>
                <td className="p-5 text-left">{val.email}</td>
                <td className="p-5 text-left">{val.server}</td>
              </tr>
            ))}
          </Table>
          <div className="flex flex-col md:flex-row justify-between items-center mt-8 pb-32">
            <div className="me-2 w-32 md:mb-0 mb-4">
              <Select.Root>
                <SelectTrigger className="SelectTrigger bg-white border-none">
                  <SelectValue placeholder="10 per Page" />
                </SelectTrigger>
                <SelectContent className="SelectContent">
                  <SelectItem value="10">10 per page</SelectItem>
                  <SelectItem value="15">15 per page</SelectItem>
                  <SelectItem value="20">20 per page</SelectItem>
                </SelectContent>
              </Select.Root>
            </div>
            <div className="pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel={window.innerWidth > 576 ? "Next  →" : ">"}
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel={window.innerWidth > 576 ? "←  Prev" : "<"}
                renderOnZeroPageCount={null}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EmailAccountsById;
